import axios from "axios";

export default {
    search(_, params){
        return axios.post(`/api/search/getinnosearch`, params, {withCredentials: true});
      },
};
